import { render, staticRenderFns } from "./coursees.vue?vue&type=template&id=070d1293&scoped=true&"
import script from "./coursees.vue?vue&type=script&lang=js&"
export * from "./coursees.vue?vue&type=script&lang=js&"
import style0 from "./coursees.vue?vue&type=style&index=0&id=070d1293&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d1293",
  null
  
)

export default component.exports